<template>
  <div class="panel-main headerBar">
    <!--pc端的header-->
    <div class="panel-content pc-header">
      <router-link :to="{name: 'Home'}">
        <h1 class="theme-logo"></h1>
      </router-link>
      <ul class="theme-nav">
        <router-link :to="{name: 'Tech'}">
          <li class="nav-item" data-line="TECHNOLOGY">
            核心技术
          </li>
        </router-link>
        <router-link :to="{name: 'Production', params: {type: 'terminal'}}">
          <li class="nav-item" data-line="PRODUCT">
            产品中心
          </li>
        </router-link>
        <router-link :to="{name: 'Solution'}">
          <li class="nav-item" data-line="SOLVE">
            解决方案
          </li>
        </router-link>
        <router-link :to="{name: 'Case', params: {type: 'bio'}}">
          <li class="nav-item" data-line="CASE">
            经典案例
          </li>
        </router-link>
        <router-link :to="{name: 'AboutUs'}">
          <li class="nav-item" data-line="US">
            关于我们
            <ul class="nav-child">
              <li>
                <router-link :to="{name: 'News'}">资讯中心</router-link>
              </li>
              <li>
                <router-link :to="{name: 'CompanyProfile'}">公司介绍</router-link>
              </li>
              <li>
                <router-link :to="{name: 'JoinUs'}">加入我们</router-link>
              </li>
            </ul>
          </li>
        </router-link>
      </ul>
      <div class="right-ctenr">
        <div class="phone-number">
          400-900-1823
        </div>
        <a class="web-link" href="http://console.yun.bjewaytek.com/" target="_blank">
          一维云
        </a>
      </div>
      <span class="i-menu" :class="{'active': isNav}" @click="toggleNav">
        <em class="i-menu-1"></em>
        <em class="i-menu-1"></em>
      </span>
    </div>

    <!--移动端的header-->
    <div class="panel-content mb-show">
      <router-link :to="{name: 'mHome'}" v-show="!isBack">
        <h1 class="theme-logo"></h1>
      </router-link>
      <div class="backBtn" v-show="isBack" @click="goBack">
        返回
      </div>

      <div class="title-ctner">{{title}}</div>

      <span class="i-menu" :class="{'active': isNav}" @click="toggleNav">
        <em class="i-menu-1"></em>
        <em class="i-menu-1"></em>
      </span>

      <ul class="theme-nav" :class="{'active': isNav}" @click="toggleNav">
        <router-link :to="{name: 'mHome'}" class="mb-show">
          <li class="nav-item" data-line="RETURN">
            返回首页
          </li>
        </router-link>
        <router-link :to="{name: 'mTech'}">
          <li class="nav-item" data-line="TECHNOLOGY">
            核心技术
          </li>
        </router-link>
        <router-link :to="{name: 'mProduction', params: {type: 'terminal'}}">
          <li class="nav-item" data-line="PRODUCT">
            产品中心
          </li>
        </router-link>
        <router-link :to="{name: 'mSolution'}">
          <li class="nav-item" data-line="SOLVE">
            解决方案
          </li>
        </router-link>
        <router-link :to="{name: 'mCase', params: {type: 'bio'}}">
          <li class="nav-item" data-line="CASE">
            经典案例
          </li>
        </router-link>
        <router-link :to="{name: 'mAboutUs'}">
          <li class="nav-item" data-line="US">
            关于我们
          </li>
        </router-link>
      </ul>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'headerBar',
    data () {
      return {
        isNav: false,
        isBack: false,
        titleMap: {},
        title: ''
      }
    },
    watch: {
      '$route' (to, from) {
        this.headerCtrl(to);
      }
    },
    methods: {
      toggleNav () {
        this.isNav = !this.isNav;
      },
      headerCtrl (to) {
        if (to.name && (to.name.toLowerCase() !== 'home' && to.name.toLowerCase() !== 'mhome')) {
          this.isBack = true;
        } else {
          this.isBack = false;
        }
        this.title = this.titleMap[to.name];
        document.title = this.titleMap[to.name] ? this.titleMap[to.name] + '  一维大成科技有限公司' : '一维大成科技有限公司';
      },
      goBack () {
        this.$router.back();
      }
    },
    created () {
      this.$router.options.routes.forEach(n => {
        this.titleMap[n.name] = n.title;
        if (n.children) {
          n.children.forEach(m => {
            this.titleMap[m.name] = m.title;
            if (m.children) {
              m.children.forEach(x => {
                this.titleMap[x.name] = x.title;
              });
            }
          });
        }
      })

      this.headerCtrl(this.$route);
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  @import '../assets/style/base.scss';

  .headerBar {
    height: 60px;
    background: #fff;
    position: sticky;
    left: 0;
    top: 0;
    z-index: 999;

    .mb-show{
      display: none;
    }

    .panel-content {
      @include public_content();
      @include clear();
      height: 100%;
      background: #fff;
      .theme-logo,
      .theme-nav,
      .phone-number {
        float: left;
      }
      .theme-logo {
        width: 105px;
        height: 36px;
        margin-top: 10px;
        /*margin-right: 90px;*/
        background: url('../assets/images/theme-logo.png') no-repeat;
        -webkit-background-size: contain;
        background-size: contain;
      }
      .theme-nav {
        @include clear();
        $h: 60px;
        $iw: 98px;
        height: $h;
        margin-left: 190px;
        line-height: $h;
        position: relative;
        z-index: 1;
        .router-link-active {
          .nav-item {
            color: #fff;
            background: #00ccff;
          }
        }
        .nav-item {
          width: $iw;
          height: $h;
          font-size: 14px;
          line-height: $h;
          text-align: center;
          float: left;
          cursor: pointer;
          position: relative;
          overflow: hidden;
          &:hover {
            color: #fff;
            background: #00ccff;
            overflow: inherit;
            .nav-child {
              display: block;
              top: $h + 6px;
            }
          }
          .nav-child {
            position: absolute;
            top: $h;
            display: block;
            border-radius: 3px;
            background-color: #fff;
            padding: 11px 0;
            width: 142px;
            color: #676767;
            box-shadow: 0 0 3px rgba(42, 42, 42, .65);
            display: none;
            &:before {
              content: ' ';
              display: block;
              height: 10px;
              position: absolute;
              top: -8px;
              width: 100%;
            }
            &:hover {
              display: block;
            }
            li {
              height: 44px;
              line-height: 44px;
              text-align: center;
              &:hover {
                background-color: #e3e3e3;
              }
              a {
                padding: 0 10px;
                display: block;
                color: inherit;
                &.router-link-active {
                  background-color: #e3e3e3;
                }
              }
            }
          }
        }
      }
      .right-ctenr{
        float: right;
        & > *{
          display: inline-block;
          height: 22px;
          margin-top: 18px;
          color: #00ccff;
        }
      }
      .phone-number {
        font-size: 18px;
        font-weight: bold;
        line-height: 25px;
        padding-left: 30px;
        background: url('../assets/images/i-phone.png') no-repeat;
      }
      .web-link{
        font-size: 14px;
        margin-top: 20px;
        margin-left: 40px;
        padding-left: 38px;
        background: url('../assets/images/i-ewaycloud.png') no-repeat;
        position: relative;
        &:before{
          content: '';
          display: inline-block;
          width: 0;
          height: 1em;
          border-left: 1px solid #eeeeee;
          position: absolute;
          left: -20px;
          top: 3px;
        }
      }
    }
  }

  .mobile {
    .pc-header{
      display: none;
    }
    .headerBar {
      height: .88rem;
      padding: 0 .30rem;
      background: rgba(255, 255, 255, .96);
      position: relative;
      z-index: 100;
      /*box-shadow: 0 0 .15rem rgba(0, 0, 0, .1);*/

      .mb-show{
        display: block;
      }

      .panel-content {
        width: 100%;
        .theme-logo {
          margin-top: .14rem;
          width: 1.70rem;
          height: .60rem;
          opacity: .86;
        }
        .backBtn{
          position: absolute;
          left: 0;
          top: 0;
          z-index: 50;
          height: .88rem;
          width: .80rem;
          background: #f0f;
          font-size: 0;
          background: url('../assets/images/i-back.png') no-repeat center center;
          -webkit-background-size: .20rem;
          background-size: .20rem;
        }

        .title-ctner{
          height: .88rem;
          line-height: .88rem;
          text-align: center;
          font-size: .38rem;
          color: #484848;
          font-weight: lighter;
        }

        .i-menu{
          width: .50rem;
          height: .88rem;
          display: inline-block;
          padding-top: .28rem;
          position: absolute;
          z-index: 50;
          top: 0;
          right: .30rem;

          @include clear();
          em:before,
          em:after{
            content: ' ';
            float: right;
            width: .45rem;
            height: .02rem;
            background: #484848;
            border-radius: 3px;
            margin-bottom: .055rem;
            transition: all linear .2s;
          }
          em:last-child:after{
            width: 65%;
          }

          &.active{
            em:first-child:before,
            em:last-child:after{
              display: none;
            }
            em:before{
              transform-origin: 48% 50%;
            }
            em:after{
              transform-origin: 20% 50%;
              position: relative;
              right: -.04rem;
              /*top: .01rem;*/
            }
            em:before{
              transform: rotate(-45deg);
            }
            em:after{
              transform: rotate(45deg);
            }
          }
        }

        .theme-nav {
          position: fixed;
          top: .88rem;
          right: 100%;
          background: rgba(255, 255, 255, .96);
          margin-left: 0;
          width: 100%;
          height: 100vh;
          padding-top: 1.00rem;
          transition: all ease .2s;
          &.active{
            right: 0;
          }
          li {
            float: none;
            font-size: .40rem;
            color: #484848;
            height: 1.45rem;
            line-height: 1.45rem;
            font-weight: lighter;
            &.nav-item,
            &:hover{
              width: 100%;
              text-align: right;
              background: transparent;
              color: #484848;
              overflow: hidden;
              &:before {
                content: attr(data-line);
                display: block;
                position: static;
                background: transparent;
                width: 3.80rem;
                float: right;
                text-align: left;
                margin-left: .20rem;
                color: #a6a6a6;
                font-size: .40rem;
                line-height: 1.52rem;
              }
            }
          }
          .router-link-active .nav-item {
            background-color: transparent;
            line-height: 1.45rem;
            color: #484848;
          }
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/HeaderBar.vue